class NotreActionController {
  constructor() {
    console.log('notre-action');
  }
}

NotreActionController.$inject = [];

module.exports = NotreActionController;



// WEBPACK FOOTER //
// ./src/app/components/notre-action/notre-action.controller.js